import type { FirebaseRepository } from './FirebaseRepository'
import type { MobxDocument } from '../types'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import {
  type FirestoreSectionAssignmentConversation,
  empty,
} from '../firestore/SectionAssignmentConversation/schema'

export class SectionAssignmentConversation extends ObservableModelWithDecorators<FirestoreSectionAssignmentConversation> {
  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreSectionAssignmentConversation>
  ) {
    super(repository, doc)
  }

  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }
}
